"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrompts = void 0;
const react_1 = require("react");
const prompt_context_1 = require("./prompt-context");
function usePrompts(prompts, deps = []) {
    const { registerPrompts, unregisterPrompts } = (0, react_1.useContext)(prompt_context_1.PromptContext);
    (0, react_1.useEffect)(() => {
        registerPrompts(prompts);
        return () => {
            unregisterPrompts(prompts);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
exports.usePrompts = usePrompts;
//# sourceMappingURL=prompt-register-hook.js.map